import axios from "axios";
import {
  GET_CONTACT_US,
  GET_DETAILS_CONTACT_US,
  POST_CONTACT_US,
  PUT_CONTACT_US_ORDER,
  PUT_STATUS_CONTACT_US,
} from "../../apiConstants";

/**
 * get contact us data
 * @param {Parameters} paramObj
 * @returns
 */
export const getContactUs = (paramObj) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${GET_CONTACT_US}`, {
    headers: { Authorization: jwt_token },
    params: paramObj,
  });
};

/**
 * enable-disable
 * @param {body} body
 * @returns
 */
export const updateStatus = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${PUT_STATUS_CONTACT_US}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

/**
 * create contact us
 * @param {body} body
 * @returns
 */
export const postContactUs = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}${POST_CONTACT_US}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

/**
 * update contact us
 * @param {body} body
 * @returns
 */
export const putUpdateContactUs = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(`${process.env.REACT_APP_API_URL}${POST_CONTACT_US}`, body, {
    headers: { Authorization: jwt_token },
    params: { contactUsId: body.contactUsId },
  });
};

/**
 * delete contact us
 * @param {id} contactUsId
 * @returns
 */
export const deleteContactUs = (contactUsId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.delete(`${process.env.REACT_APP_API_URL}${POST_CONTACT_US}`, {
    headers: { Authorization: jwt_token },
    params: { contactUsId },
  });
};

/**
 * get details contact us
 * @param {id} contactUsId
 * @returns
 */
export const getDetailsContactUs = (contactUsId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(
    `${process.env.REACT_APP_API_URL}${GET_DETAILS_CONTACT_US}`,
    {
      headers: { Authorization: jwt_token },
      params: { contactUsId },
    }
  );
};

/**
 * short order contact us
 * @param {body} updateOrder
 * @returns
 */
export const sort_order_ContactUs = (updateOrder) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${PUT_CONTACT_US_ORDER}`,
    { updateOrder: updateOrder },
    {
      headers: { Authorization: jwt_token },
    }
  );
};
